import { Leaf, Snowflake } from 'lucide-react';

export const SEASONS = {
  fall: {
    label: 'Fall Heating, Cooling & Plumbing Guide',
    short: 'Fall Guide',
    Icon: Leaf,
    className: 'bg-gradient-to-r from-orange-500 to-red-600',
  },
  winter: {
    label: 'Winter Heating & Plumbing Guide',
    short: 'Winter Guide',
    Icon: Snowflake,
    className: 'bg-gradient-to-r from-sky-500 to-[#14366C]',
  },
};

// Sep–Nov = fall, Dec–Feb = winter, otherwise null
export const getCurrentSeason = (date = new Date()) => {
  const m = date.getMonth();
  if (m >= 8 && m <= 10) return 'fall';
  if (m === 11 || m <= 1) return 'winter';
  return null;
};

export const SeasonBadge = ({ season, short = false, className = 'px-3 py-1 text-xs' }) => {
  const cfg = SEASONS[season];
  if (!cfg) return null;
  const { Icon } = cfg;
  return (
    <span
      className={`inline-flex items-center rounded-full font-bold text-white ${cfg.className} ${className}`}
      data-testid={`season-badge-${season}`}
    >
      <Icon className="w-3.5 h-3.5 mr-1.5" aria-hidden="true" />
      {short ? cfg.short : cfg.label}
    </span>
  );
};
